import { Record } from 'immutable';

const FundingDocumentRecord = Record({
  id: '',
  filename: '',
});

export default class FundingDocument extends FundingDocumentRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    return new FundingDocument(jsonObject);
  }

  get fileExtention() {
    const parts = this.filename.split('.');

    return parts && parts.length ? parts[parts.length - 1] : '';
  }
}
